import type { Shadows } from '@mui/material';

import palette from './palette';

export default [
  'none',
  '0px 0px 2px 0px #0000001F, 0px 4px 8px 0px #00000024',
  `0px 0px 0px 2.5px ${palette.primary[200]}`,
  '0px 2px 10px 0px #0000000D',
  '2px 0 2px -1px #0000001F, 0 -2px 2px -1px #0000001F',
  `0px 0px 0px 2.5px ${palette.background.default}`,
  '0 0 16px 0 rgba(197, 197, 197, 0.80)',
  '0 4px 12px 0 #D0D0D0',
  '0 4.093px 16.372px 0 #D0D0D0',
  '0px 4.093px 20px 0px #C3C3C3',
  '0px 0px 5px 1px #5209e6',
  '5px 4px 16px 0 #ECEBEB',

  ...Array(20).fill('none')
] as Shadows;
